export default __webpack_public_path__ + "static/media/close-icon.8cf57c3d.svg";